import { GameMap, GameMapData } from './map';
import { resolveTurnSync } from './resolver';
import { User, UserData } from './user';
import { clone } from './utils';

export type GameData = {
  id: string;
  maxTurns: number;
  maxVictoryPoints: number;
  maps: GameMapData[];
  users: UserData[];
};

export class Game {
  data: GameData;
  users: User[];

  constructor(data: GameData) {
    this.data = data;
    this.users = data.users.map((userData) => new User(this, userData));
  }

  get turn() {
    return this.data.maps.length;
  }

  get nextId() {
    return this.latestMap.nextId;
  }

  get latestMap() {
    return this.data.maps[this.data.maps.length - 1];
  }

  get winners() {
    return new GameMap(this.latestMap).winningPlayers(this.data.maxVictoryPoints, this.turn > this.data.maxTurns);
  }

  resolveTurn() {
    if (this.winners.length > 0) throw new Error('Unable to resolve turn -- game is in a completed state!');
    const next = new GameMap(clone(this.latestMap));
    resolveTurnSync(next);
    this.data.maps.push(next.data);
  }
}



// WEBPACK FOOTER //
// ../models/src/game.ts